import { dispatchAlerts, onErroredResponse } from "./responseConverters";
import { UNKNOWN_ERROR } from "../messages/errorsMessages";
import { ApiResult } from "../models/ApiResult";

export default async (
  throwableFunction: Function,
  onSuccess: Function,
  dispatch: Function,
  onFinish: Function = () => {},
  onError: Function = () => {}
) => {
  let response: ApiResult = {} as ApiResult;
  let isAborted = false;
  try {
    response = await throwableFunction();
    if (response.isError) {
      dispatch(onErroredResponse(response.errorTable));
      onError();
    } else {
      onSuccess(response.result);
      const alerts = dispatchAlerts(response);
      alerts && dispatch(alerts);
    }
  } catch (error) {
    if (error.name !== "AbortError") {
      console.log(error);
      dispatch(onErroredResponse([UNKNOWN_ERROR]));
      onError();
    } else {
      isAborted = true;
    }
  } finally {
    !isAborted && onFinish();
  }
  return !response.isError;
};
